import styled from '@emotion/styled'

const FooterElement = styled.footer`
    background-color: #242f3f;

    li {
        width: 100%;
        padding: 0.25rem 0 0.25rem 0;
        border-left: 3px solid transparent;

        a {
            color: white;
            padding: 0.25rem;
            margin: -0.25rem -0.5rem;
        }

        @media (min-width: ${props => props.theme.bps.xl}) {
            a {
                font-size: 2rem;
            }
        }

        @media (max-width: ${props => props.theme.bps.lg}) {
            a {
                font-size: 1.2rem;
            }
        }
    }

    .footer-body {
        padding: 0 8rem 0.5rem;
        color: white;
        display: flex;
        flex-direction: column;

        @media (max-width: ${props => props.theme.bps.lg}) {
            padding: 0 4rem 1rem;
        }

        .logo-container {
            position: relative;
            width: 10rem;
            margin: 0 auto;

            @media (min-width: ${props => props.theme.bps.sm}) {
                margin: 0;
            }
        }

        .footer-content-row {
            margin: 3rem 0;

            display: flex;
            justify-content: space-between;

            @media (max-width: ${props => props.theme.bps.lg}) {
                flex-direction: column;
                justify-content: space-between;
            }

            .footer-branding-section {
                min-width: 20rem;
                margin-top: 2rem;
                display: flex;
                flex-direction: column;
                gap: 4rem;
                align-items: flex-start;

                .footer-branding-text {
                    @media (min-width: ${props => props.theme.bps.xl}) {
                        font-size: 1.5rem;
                    }
                }

                h4 {
                    font-size: 1.25rem;
                }
            }

            .footer-links-section {
                width: 40%;

                display: grid;
                grid-template-columns: repeat(1, 1fr);
                gap: 5rem;

                justify-content: center;
                margin: 2rem 0;

                @media (min-width: ${props => props.theme.bps.lg}) {
                    margin: 0;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 3rem;
                }
                @media (min-width: ${props => props.theme.bps.xl}) {
                    margin: 0 2rem;
                    grid-template-columns: repeat(2, 1fr);
                }

                .link-list-column {
                    text-color: white;
                    min-width: 10rem;

                    .column-header {
                        padding-bottom: 1rem;
                        font-weight: bold;

                        @media (min-width: ${props => props.theme.bps.lg}) {
                            padding-bottom: 1.5rem;
                        }
                    }

                    .link-list {
                        min-width: 10rem;

                        li a {
                            @media (min-width: ${props => props.theme.bps.xl}) {
                                font-size: 1.5rem;
                            }
                            color: white !important;
                        }
                    }

                    .link-grid {
                        width: fit-content;

                        display: grid;
                        grid-template-columns: 1fr 1fr 1fr;
                        row-gap: 0.25rem;
                        column-gap: 1.5rem;

                        @media (max-width: ${props => props.theme.bps.lg}) {
                            row-gap: 0.15rem;
                            column-gap: 3rem;
                        }
                    }
                }
            }
        }
    }

    .footer-menu {
        background-color: #242f3f;

        width: 100%;
        min-height: 5rem;
        padding: 2rem 5rem 3rem 5rem;

        @media (min-width: ${props => props.theme.bps.lg}) {
            padding: 2rem 5rem 3rem 8rem;

            display: flex;
            justify-content: space-between;
        }

        @media (max-width: ${props => props.theme.bps.sm}) {
            padding: 1rem;
        }

        p {
            @media (max-width: ${props => props.theme.bps.sm}) {
                text-align: center;
            }
            
            @media (min-width: ${props => props.theme.bps.xl}) {
                font-size: 1.5rem;
            }
            color: white;
            font-size: 1.15rem;
        }

        ul {
            max-width: 35rem;
            margin-right: 5rem;

            text-align: left;
            white-space: nowrap;

            display: flex;
            flex-direction: column;
            gap: 1.5rem;

            @media (min-width: ${props => props.theme.bps.lg}) {
                text-align: center;

                display: flex;
                gap: 6rem;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            }
            @media (max-width: ${props => props.theme.bps.sm}) {
                display: flex;
                flex-direction: column;
                margin: 0 auto;
                text-align: center;
                gap: 0;

            li a {
                color: white !important;
                text-decoration: none;
            }
        }
    }
`

const OrderTrack = styled.form`
    height: fit-content;
    margin: 1.5rem 0;
    width: 16rem;

    display: flex;
    gap: 1.5rem;
    flex-direction: column;

    label {
        font-weight: bold;
        font-size: 1.125rem;

        @media (min-width: ${props => props.theme.bps.lg}) {
            font-size: 1.375rem;
        }
    }

    .input-container {
        background-color: ${props => props.theme.colors.white};

        border: 1px solid ${props => props.theme.colors.primary};
        border-radius: 10px;

        display: flex;

        input {
            width: 100%;
            border-radius: 10px;
            padding: 0.5rem 1.5rem;

            &::placeholder {
                font-size: 0.8rem;
                /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: ${props => props.theme.colors.primary};
                opacity: 1; /* Firefox */
            }
            &::-ms-input-placeholder {
                font-size: 0.8rem;
                /* Microsoft Edge */
                color: ${props => props.theme.colors.primary};
            }
        }

        button {
            position: relative;
            height: 1.8rem;
            width: 3rem;
            margin: auto;
            padding: 0 0.5rem;

            .search-icon {
                position: relative;
                height: 1.25rem;
            }
        }
    }
`

const Legal = styled.div`
    font-size: 0.75rem;
    text-align: center;

    > div {
        padding: 0.75rem 0;
    }

    @media (min-width: ${props => props.theme.bps.lg}) {
        font-size: 0.85rem;
    }

    @media (min-width: ${props => props.theme.bps.sm}) {
        text-align: unset;
    }
`

export { Legal, OrderTrack, FooterElement }

